import { DriverAuthenticationClient, DriverAuthenticationManager } from '@frontend/authentication-v2';
import { Logger } from '@frontend/logger';
import { IUser } from '@frontend/user/types';

import { AppDispatch } from '../../redux/store';
import { startUserSession } from '../../redux/terminal-navigation-slice';

export async function authenticateKioskUser(dispatch: AppDispatch, accountId: string, iotId: string, user: IUser): Promise<boolean> {
    try {
        const token = await DriverAuthenticationManager.getInstance().waitForToken();
        let auth = await DriverAuthenticationClient.authorizeUser(accountId, iotId, user.id, token).catch(() => null);

        if (!auth) {
            const info = DriverAuthenticationManager.getInstance().provisionInfo;
            if (info) {
                await DriverAuthenticationManager.getInstance().authenticate(info);
                auth = await DriverAuthenticationClient.authorizeUser(accountId, iotId, user.id, token).catch(() => null);
            }
        }

        if (!auth) return false;

        dispatch(startUserSession({ id: user.id, accountId, auth, user }));
        return true;
    } catch (error) {
        Logger.error('Error during kiosk user authentication:', error);
        return false;
    }
}
